import React from 'react';

const PointerToTheRightIcon = (props) => (
  <svg {...props} viewBox='0 0 23 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.52372 4.57052H1V15.8798H5.52372M5.52372 4.57052V15.8798M5.52372 4.57052L10.2686 2.01397C11.1323 1.47911 12.0267 0.723931 12.9863 1.10212C13.091 1.1434 13.1971 1.1851 13.2951 1.24052C14.0334 1.65801 14.2009 3.18353 13.1404 3.71242L11.3995 4.57052H19.7286C23.0531 4.57052 22.4877 7.66928 21.3567 7.66928H16.1097C16.1097 8.01628 16.833 8.52306 16.833 9.48197M5.52372 15.8798H15.9724C16.0638 15.8798 16.1556 15.8754 16.2419 15.8453C16.5387 15.7417 17.165 15.3518 16.2675 14.0057C16.2915 13.653 16.8601 12.8221 16.833 12.3093C16.833 11.979 15.7021 11.1784 16.1097 10.878M16.833 9.48197C16.833 9.8616 16.4305 10.3968 16.1097 10.878M16.833 9.48197L16.6028 10.1226L16.1097 10.878'
      stroke={props.fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default PointerToTheRightIcon;
